import $ from 'jquery';

class ExternalUrlAnchors {
    constructor() {}

    init() {
        this.bindEvents();
    }

    bindEvents() {
        let anchorTags = $('main a');
        anchorTags.each((index, elem) => {
            let hrefValue = $(elem).attr('href');
            
            if (this.verifyExternalUrl(hrefValue) && !hrefValue.startsWith('tel')) {
                $(elem).attr('target', '_blank');
            }
        });
    }

    verifyExternalUrl(url) {
        const temp = document.createElement('a');
        temp.href = url;
        return temp.host !== window.location.host;
    }
}

export default ExternalUrlAnchors;

$(() => {
    const externalUrlAnchors = new ExternalUrlAnchors();
    externalUrlAnchors.init();
});